import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent } from './log-out.svg';


export const LogOutIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={ReactComponent} />
);
